import React, { type ReactNode } from 'react';
interface TextProps {
  className: string;
  children: ReactNode;
}
function Text({ className, children }: TextProps) {
  return <p className={className}>{children}</p>;
}

export default Text;
